import React from "react";
import { wrapCollectionLayout } from '@quintype/components';
import { FullscreenStoryList } from "../layout/fullscreen-story-list";
import "./one-col-story-list.module.css";


function OneColStoryListBase(props) {
  const {collection, associatedMetadata, config, onLoadMore, noMoreStories, stories} = props;
  return (
    <div styleName="one-col-story-list">
      <FullscreenStoryList
        config={Object.assign({}, config, { 'collection-name': collection.name })}
        stories={stories}
        associatedMetadata={associatedMetadata}
        onLoadMore={onLoadMore}
        noMoreStories={noMoreStories} />
    </div>
  );
}

export const OneColStoryList = wrapCollectionLayout(OneColStoryListBase);

